import React, { useState } from "react";
import { TextField } from "@mui/material";
import { formatMobileNumber, toMobileDigits } from "../../../utils/mobile";

interface MobileNumberFieldProps {
  initState: string;
  id?: any;
  inputChange?: any;
  error?: any;
  helperText?: any;
  required?: boolean;
  disabled?: boolean;
}

const MobileNumberField: React.FC<MobileNumberFieldProps> = (props) => {
  // Display is formatted "0400 000 000"; the value emitted to the parent is digits-only
  // ("0400000000") for storage. Validation runs on the digits (see utils/mobile.ts), so
  // wrong prefix / wrong length still fail while spacing is handled purely for display.
  const [inputValue, setInputValue] = useState(formatMobileNumber(props.initState));

  const handleInputChange = (e: any) => {
    const digits = toMobileDigits(e.target.value);

    // Show the grouped form to the user...
    setInputValue(formatMobileNumber(digits));
    // ...but emit digits-only so callers store 0400000000, not "0400 000 000".
    props.inputChange(digits);
  };

  return (
    <TextField
      key={props.id}
      margin="dense"
      id={"mobile" + props.id ? props.id : ""}
      name="mobile"
      label="Mobile Number"
      type="text"
      fullWidth
      variant="outlined"
      value={inputValue}
      onChange={handleInputChange}
      error={props.error}
      helperText={props.helperText}
      required={props.required}
      disabled={props.disabled}
    />
  );
};

export default MobileNumberField;
